module.exports = "./img/0369cde519d4ebdfef22e040fc228849.jpg";